import {Injectable} from "@angular/core";
import {WindowRef} from "./window-ref";

@Injectable()
export class NewRelicService {

    constructor(private _window: WindowRef) {
    }

    noticeError(error: any): void {
        const nativeWindow = this._window.nativeWindow;
        const hasNewRelic = !!(nativeWindow && nativeWindow.newrelic);
        const hasNREUM = !!(nativeWindow && nativeWindow.NREUM);

        if (hasNewRelic && nativeWindow.newrelic.noticeError) {
            nativeWindow.newrelic.noticeError(error);
        } else if (hasNREUM && nativeWindow.NREUM.noticeError) {
            nativeWindow.NREUM.noticeError(error);
        } else {
            console.warn("Cannot log on newrelic, api is not loaded", {
                error,
                hasNewRelic,
                hasNREUM
            });
        }
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/newrelic.service.ts